module.exports = __webpack_public_path__ + "img/be_the_change_yoga.dd6c2268.png";